import React from 'react'
import {
  Box,
  Text,
  CheckBox,
  Anchor,
} from '@usap/uicomponents'

const AddProtectionPlan = ({
  customStyle,
  handleWarranty,
  isChecked,
  handleShowTooltip,
  dataTestId,
}) => (
  <Box direction="row" margin={customStyle.checkBoxWrapperMargin}>
    <CheckBox
      checked={isChecked}
      label={(
        <Text size="small" color="dark-2">
          {'Add protection plan '}
        </Text>
      )}
      onChange={handleWarranty}
      data-testid={dataTestId?.protectionPlanCheckbox}
    />
    <Anchor
      data-testid={dataTestId?.whatsThis}
      margin={customStyle.tooltipTextMargin}
      size="small"
      onClick={handleShowTooltip}
      label={(
        <Text size="xsmall" weight="bold" color="blueLink">
          What&apos;s this?
        </Text>
      )}
    />
  </Box>
)

export default AddProtectionPlan
